"use client"

import { useQuery } from "@tanstack/react-query"

import { getShopifyTopupIncidentAction } from "@/server-actions/shopify/topup-admin"

export function shopifyTopupIncidentQueryKey(tenantId: string) {
  return ["shopify", "topup-incident", tenantId] as const
}

export function useShopifyTopupIncidentQuery(tenantId: string, enabled: boolean) {
  return useQuery({
    queryKey: shopifyTopupIncidentQueryKey(tenantId),
    enabled,
    queryFn: async () => {
      const result = await getShopifyTopupIncidentAction({ tenantId })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
